"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _colors = require("HubStyleTokens/colors");

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  color: ", " !important;\n  background-color: ", " !important;\n  &:hover {\n    background-color: ", " !important;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var _default = (0, _styledComponents.default)(_UIButton.default).withConfig({
  displayName: "StyleProtectedMenuButton",
  componentId: "pg0ksb-0"
})(_templateObject(), _colors.OBSIDIAN, _colors.OLAF, _colors.CALYPSO_LIGHT);

exports.default = _default;
module.exports = exports.default;